import { MessageTemplateCreatePage } from './messageTemplate.create.page';

export default MessageTemplateCreatePage;
